import React from "react"
export function RightChevronFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zM8.972 5.599l-1.13.988 3.068 3.506-3.067 3.506 1.129.988 3.5-4 .066-.09a.75.75 0 000-.81l-.066-.088-3.5-4z"
        fill="currentColor"
        id="prefix__right-chevron---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
